const dataRoadMap = [
    {
        time: 'February 01, 2022',
        title: 'Idea Generation',
        desc: 'Oficia dese runt mollit anim id est labo met conse ctetur adipi smod tempor inc ididunt ut labore et dolore quis',
        class: 'left'
    },
    {
        time: 'March 30, 2022',
        title: 'Design & Development',
        desc: 'Oficia dese runt mollit anim id est labo met conse ctetur adipi smod tempor inc ididunt ut labore et dolore quis',
        class: 'right mt-223'
    },
    {
        time: 'April 20, 2022',
        title: 'Initial Release',
        desc: 'Oficia dese runt mollit anim id est labo met conse ctetur adipi smod tempor inc ididunt ut labore et dolore quis',
        class: 'left mt--23'
    },
    {
        time: 'May 30, 2022',
        title: 'Result & Final Report',
        desc: 'Oficia dese runt mollit anim id est labo met conse ctetur adipi smod tempor inc ididunt ut labore et dolore quis',
        class: 'right mt-200'
    },
]

export default dataRoadMap;